module.exports = __webpack_public_path__ + "assets/cloudflare.c83bf52a.svg";